import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=6b5318c2&scoped=true"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"
import style0 from "./Share.vue?vue&type=style&index=0&id=6b5318c2&prod&scoped=true&lang=css"
import style1 from "./Share.vue?vue&type=style&index=1&id=6b5318c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5318c2",
  null
  
)

export default component.exports